import Modal from "react-modal";
import { colors } from "../../data/colors";
import { documentModalStyles } from "../../data/styles/modalStyles";
import Header from "../componentModal/Header";
import MenuList from "../componentModal/MenuList";
import { stdObject } from "../../data/types/stdObject";
import useStationeryModal from "./useStationeryModal";
import ZoomBox from "./components/ZoomBox";
import PageModel from "./components/PageModel";
import { StationeryContext } from "../../context/MainContext";
import LoadingScreen from "../LoadingScreen";
import SectionBox from "./components/SectionBox";

export default function StationeryModal({
  open = false,
  info,
}: {
  open: boolean;
  info: stdObject;
}) {
  const {
    t,
    type,
    mainColor,
    squareButtons,
    tabIndex,
    switchTab,
    paperData,
    tabs,
    fileInputRef,
    scaleInfo,
    resizeZoom,
    resizePage,
    pageDiv,
    deskDiv,
    flexDir,
    buttons,
    listItems,
    actives,
    handleActive,
    selected,
    setSelected,
    editValues,
    assignItem,
    printOptions,
    isPrint,
    isDoc,
    printData,
    pages,
    hiddenDiv,
    printArea,
    inputsValues,
    setInputsValues,
    showScreen,
    ticketsList,
    hasTicket,
    selectTicket,
    processTxt,
  } = useStationeryModal({
    open,
    info,
  });

  return (
    <StationeryContext.Provider
      value={{
        tabIndex,
        resizeZoom,
        scaleInfo,
        isPrint,
        isDoc,
        printOptions,
        paperData,
        selectTicket,
        hasTicket,
        actives,
        selected,
        handleActive,
        assignItem,
        editValues,
        type,
        deskDiv,
        pageDiv,
        flexDir,
        resizePage,
        printData,
        pages,
        printArea,
        inputsValues,
        setInputsValues,
        processTxt,
      }}
    >
      <Modal
        isOpen={open}
        onRequestClose={() => {}}
        style={documentModalStyles}
      >
        <div className="documentContainer">
          <Header
            title={paperData.data.NOMDOC}
            mainColor={mainColor}
            squareButtons={squareButtons}
            date={t(`c.${paperData.data.TIPDOC}`)}
          />
          {
            <MenuList
              tabs={tabs}
              mainColor={colors.settings}
              switchTab={(index: number) => {
                setSelected({ ...selected, index: -1, num: 0 });
                switchTab(index);
              }}
              tabIndex={tabIndex}
              buttons={buttons}
              docActive={{ status: 0 }}
              active={true}
            />
          }

          <div className="docMainContent">
            <div
              ref={hiddenDiv}
              style={{
                position: "absolute",
                visibility: "hidden",
                width: paperData.data.TANDOC,
              }}
            />
            <PageModel />
            {(!isPrint || hasTicket) && (
              <SectionBox
                listItems={hasTicket ? { 0: ticketsList } : listItems}
              />
            )}
            <ZoomBox />
            {showScreen && <LoadingScreen />}
          </div>
          <input
            type="file"
            ref={fileInputRef}
            onChange={() => {}}
            style={{ display: "none" }}
          />
        </div>
      </Modal>
    </StationeryContext.Provider>
  );
}
